import { render } from "./Boundaries.vue?vue&type=template&id=a1389844&scoped=true"
import script from "./Boundaries.vue?vue&type=script&lang=js"
export * from "./Boundaries.vue?vue&type=script&lang=js"

import "./Boundaries.vue?vue&type=style&index=0&id=a1389844&lang=scss&scoped=true"

import exportComponent from "/Users/klaus/Projects/sfdc-happy-soup/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1389844"]])

export default __exports__